import { z } from 'zod';
import { DATABASES } from '@fortem-monorepo/constants';
export const baseInstrumentSchema = z.object({
    database: z.enum(DATABASES),
    unit_multiplier: z.number(),
    quote_factor: z.number(),
});
